<ng-container>
    <mat-card class="mat-elevation-z0" [class.disabled]="disabled" [class.selected]="product.selected" (click)="onClick()">
        <span class="product-selected" [class.not-appropriateness]="!isAppropriateness" *ngIf="product.selected">
            <mat-icon>check</mat-icon>
        </span>
        <div class="product-name">
            <h2 class="mat-title text-center">{{ product.name }}</h2>
        </div>
        <div class="product-price text-center">
            <h3 class="mat-display-1 font-weight-bold my-1">{{ product.lastPrice | number: '1.2-2' }} €</h3>
            <p class="mb-0">{{ 'product.liquidation-value' | translate }}</p>
            <p class="date mb-2" *ngIf="product.lastPriceDate">
                {{ product.lastPriceDate?.toDate() | date: 'dd-MM-yyyy' }}
            </p>
        </div>
        <div class="text-center">
            <button type="button" class="mat-elevation-z0" mat-raised-button color="yellow-bordered" (click)="onDetail($event)">
                {{ 'product.look-detail' | translate }}
            </button>
        </div>
    </mat-card>
    <mat-radio-group class="d-flex justify-content-between pt-4 px-5" [(ngModel)]="product.isExonerated" *ngIf="requiredExonerate">
        <mat-radio-button color="blue-gray" [value]="false">
            {{ 'general.no' | translate }}
        </mat-radio-button>
        <mat-radio-button color="blue-gray" [value]="true">
            {{ 'general.yes' | translate }}
        </mat-radio-button>
    </mat-radio-group>
</ng-container>
